export function DetailItem({ label, icon: Icon, content, noContent = "—" }) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-0.5">
      <div className="tw:flex tw:items-center tw:gap-1.5">
        <Icon className="tw:size-3.5 tw:shrink-0 tw:text-(--color-text-muted)" />
        <span className="tw:font-medium tw:text-(--color-text-muted)">
          {label}
        </span>
      </div>
      <span className="tw:text-foreground tw:pl-5 tw:wrap-anywhere">
        {content || noContent}
      </span>
    </div>
  );
}
